<template>
  <div class="page-content">
    <main class="authorize-main">
      <div class="authorize-wrapper flex">
        <div class="authorize-text">
          <div class="authorize-logo">
            <svg class="svg-logo">
              <use href="/img/logo.svg#svg-logo"></use>
            </svg>
          </div>
          <div class="authorize-title">
            <div class="h2">
              <span class="txt-accent">{{ $t('auth.titlePrefix') }}</span> {{ $t('auth.titleSuffix') }}
            </div>
            <p class="font-14">{{ $t('auth.noAccount') }}</p>
          </div>
        </div>
        <!--Наличие пустого placeholder=" " с одним пробелом внутри - важно для анимации фейк-плейсхолдера-->
        <div class="authorize-form-wrapper">
          <Form :validation-schema="dynamicSchema"
                v-slot="{ errors, meta, handleSubmit, setFieldValue, resetForm }"
                :initial-values="user"
                :validateOnMount="false"
                v-bind="validateMode"
                @invalid-submit="handleInvalidSubmit"
          >
            <form @submit.prevent="handleSubmit((values) => onSubmit(values, resetForm))" class="authorize-form" autocomplete="off">
              <div class="error-tooltip" v-if="Object.keys(errors).length > 0">
                <span v-for="(error, key) in errors" :key="key">{{ error }}<br/></span>
              </div>
              <div class="error-tooltip" v-if="serverError">
                <span v-html="serverError"></span>
              </div>
              <Field v-slot="{ value, handleChange, field, errorMessage, handleBlur }" name="login">
            <div class="form-item has-placeholder" :class="{'not-valid': errorMessage}">
              <span class="input-icon">
                <svg class="svg-user">
                  <use href="/img/sprite.svg#svg-user"></use>
                </svg>
              </span>
              <input class="input" type="text" :value="value"
                     @input="(e) => { handleChange(e, !!errorMessage); login = e.target.value; }"
                     @blur="handleBlur" autocomplete="login" placeholder=" ">
              <span class="fake-placeholder">{{ $t('auth.login') }}</span>
            </div>
              </Field>
              <Field v-slot="{ value, handleChange, field, errorMessage, handleBlur  }" name="password">
            <div class="form-item form-passw has-placeholder" :class="{'not-valid': errorMessage, 'form-passw-active':showPassword}">
              <span class="input-icon">
                <svg class="svg-lock">
                  <use href="/img/sprite.svg#svg-lock"></use>
                </svg>
              </span>
              <input class="input" :type="!showPassword ? 'password' : 'text'" :value="value"
                     @input="(e) => { handleChange(e, !!errorMessage); password = e.target.value; }"
                     @blur="handleBlur" autocomplete="password" placeholder=" ">
              <span class="fake-placeholder">{{ $t('auth.password') }}</span>
              <span class="show-passw btn-square" @click="showPassword = !showPassword"></span>
            </div>
              </Field>
              <Field v-slot="{ field, errorMessage }" name="remember">
            <label class="checkbox-label mt-10">
              <input type="checkbox" v-model="remember">
              <span class="fake-checkbox"></span>
              <span class="checkbox-name">{{ $t('auth.remember') }}</span>
            </label>
              </Field>
            <div class="form-button mt-15">
              <button class="btn w-100" :class="{loader:isSubmitting}" type="submit">{{ $t('auth.submit') }}</button>
            </div>
          </form>
          </Form>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from 'axios';
import scrollToError from "@/mixin/scrollToError.vue";
import { Form, Field, useForm } from 'vee-validate';
import * as yup from 'yup';
import { translateApiError } from '@/utils/apiErrorUtils';

export default {
  components: {
    Form, Field
  },
  mixins: [scrollToError],
  data: () => ({
    login: '',
    password: '',
    remember: false,
    isSubmitting: null,
    serverError: null,
    successMessage: null,
    showPassword: false
  }),
  computed: {
    dynamicSchema() {
      return yup.object({
        login: yup
            .string()
            .required(this.$t('auth.validation.loginRequired'))
            .min(3, this.$t('auth.validation.loginMin'))
            .max(50, this.$t('auth.validation.loginMax'))
            .matches(/^[a-zA-Z0-9_-]+$/, this.$t('auth.validation.loginFormat')),

        password: yup
            .string()
            .required(this.$t('auth.validation.passwordRequired'))
            .min(6, this.$t('auth.validation.passwordMin'))
            .max(100, this.$t('auth.validation.passwordMax')),

        remember: yup.boolean()
      });
    },
    validateMode() {
      return {
        validateOnBlur: true,
        validateOnChange: false,
        validateOnInput: false,
        validateOnModelUpdate: false
      };
    }
  },
  methods: {
    handleInvalidSubmit() {
      this.scrollToFirstError();
    },

    async onSubmit(values, resetForm) {
      this.isSubmitting = true;
      this.serverError = null;
      this.successMessage = null;

      const formDataToSubmit = {
        login: this.login,
        password: this.password,
        remember: this.remember,
      };

      try {


        // отправка данных на сервер
        const response = await axios.post('/api/user/login/', formDataToSubmit,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            });
        if (response.data.status == 'error') {
          this.serverError= '';
          for (let i in response.data.errors) {
            console.log(typeof response.data.errors[i].code)
            if (typeof response.data.errors[i].code == 'number') {
              this.serverError = this.$t('errors.serverError');
              break;
            }
            else
              this.serverError += translateApiError(response.data.errors[i], this.$t) + "<br>";
          }
          throw new Error(this.serverError);
        }
        else {
          this.$store.commit('Auth', response.data.data);
          if (this.$store.getters.isAuth && this.$store.getters.user?.role === 'supplier') {
            this.$i18n.locale = 'en'
            this.$store.commit('setLang', 'en')
          }

          this.$router.push({ name: 'main' });
        }

      } catch (error) {
        //this.serverError = error;
        this.scrollToFirstError();
      } finally {
        this.isSubmitting = false;
      }
    },
  }
}
</script>
